export { userTripsScreenVariables } from './trips';
export { userBoatsScreenVariables } from './boats';
export { logsOfTripScreenVariables } from './logs';
export * from './manufacturers';
export { allPostTagsVariables, allPostCategoriesVariables, allNewsVariables } from './blogs';
export { activityBoatsHomePageQueryVariables } from './boatActivities';
